if (!customElements.get('cake-enquiry-form')) {
  customElements.define('cake-enquiry-form', class CakeEnquiryForm extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('form');
      const success = this.querySelector('[data-form-success]');
      const errors = this.querySelector('[data-form-errors]');
      if (success) success.focus();
      else if (errors) errors.focus();
      form?.addEventListener('submit', () => {
        const eventName = this.dataset.formType === 'commission' ? 'ads:bespoke_enquiry_submit' : 'ads:contact_submit';
        this.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
      });
    }
  });
}
